export class PromoBenefit{
   constructor(promotion_id, benefit_type, product_type, product_id, product_name, price, quantity, line_id, line_name, presentation_id, presentation_name, benefits_str){
      this.promotion_id = promotion_id
      this.benefit_type = benefit_type
      this.product_type = product_type
      this.product_id = product_id
      this.product_name = product_name
      this.price = price
      this.quantity = quantity
      this.line_id = line_id
      this.line_name = line_name
      this.presentation_id = presentation_id
      this.presentation_name = presentation_name
      this.benefits_str = benefits_str
   }

   static fromServiceBenefit(benefit){
      return new PromoBenefit(
         benefit.ID_Promocion,
         benefit.Tipo_Beneficio,
         benefit.Tipo_Producto,
         benefit.ID_Producto,
         benefit.Nm_Producto,
         benefit.Precio,
         benefit.Cantidad,
         benefit.ID_Linea,
         benefit.Nm_Linea,
         benefit.ID_Presentacion,
         benefit.Nm_Presentacion,
         benefit.Beneficios_String
      );
   }

}